import { createSelector } from 'reselect';
import { AnnoncementView } from '@Selectors/builder/view/AnnoncementView';
import {
  getAnnoncement,
  getAnnoncementHidden,
} from '@Selectors/builder/selector/getAnnoncement';

export const PresentAnnoncementPresenter = createSelector(
  [getAnnoncement, getAnnoncementHidden],
  (annoncement, hidden): AnnoncementView | null => {
    if (!annoncement || hidden) return null;

    return {
      id: annoncement.id,
      title: annoncement.title,
      content: annoncement.content,
      publishedAt: new Date(
        annoncement.publishedAt * 1000,
      ).toLocaleDateString(),
    } satisfies AnnoncementView as AnnoncementView;
  },
);
